import { useState, useRef, useLayoutEffect } from 'react';

const useSwipe = ({
    open,
    onClose,
    paperRef,
    hysteresis = 0.52,
}: {
    open: boolean;
    onClose: () => void;
    paperRef: React.RefObject<HTMLElement>;
    hysteresis?: number;
}) => {
    const [transform, setTransform] = useState('inherit');
    const [startY, setStartY] = useState(0);
    const swipeInstance = useRef({
        currentY: 0,
    });

    useLayoutEffect(() => {
        if (!open) {
            swipeInstance.current.currentY = 0;
        }
    }, [open]);

    const onTouchStart = (e: React.TouchEvent<HTMLElement>) => {
        setTransform('inherit');
        setStartY(e.touches[0].clientY);
    };

    const onTouchMove = (e: React.TouchEvent<HTMLElement>) => {
        swipeInstance.current.currentY = e.touches[0].clientY;

        if (e.touches[0].clientY >= startY) {
            setTransform(`translateY(${e.touches[0].clientY - startY}px)`);
        }
    };

    const onTouchEnd = (e: React.TouchEvent<HTMLElement>) => {
        const clientHeight = paperRef?.current?.clientHeight;
        const delta = swipeInstance.current.currentY - startY;
        if (!clientHeight) return;

        if (delta / clientHeight < hysteresis) {
            setStartY(0);
            setTransform('inherit');
        } else {
            setTransform(`translateY(${clientHeight}px)`);
            onClose();
        }
    };

    return {
        onTouchMove,
        onTouchStart,
        onTouchEnd,
        transform,
    };
};

export default useSwipe;
